import React from 'react';
import PropTypes from 'prop-types';

import { Trans } from '../../../components';
import LinkServiceLookupForm from '../../../components/common/Forms/LinkServiceLookupForm/LinkServiceLookupForm';
import {
  DpsLinkingLockoutModal,
  DpsDlrLockoutModal,
  DpsGuidMismatchModal,
} from '../../../components/common/modals';

const LinkServiceIdentityView = ({
  agency,
  app,
  appParams,
  initialValues,
  onSubmit,
  onBack,
}) => (
  <div className="link-services step-up-identity">
    <h2 className="page-header">
      <Trans
        file="LinkService"
        id="StepUpIdentityTitle"
        fallback="Enter your Texas driver license or ID information"
      />
    </h2>

    <LinkServiceLookupForm
      appParams={appParams}
      initialValues={initialValues}
      agency={agency}
      app={app}
      onSubmit={onSubmit}
      validateOnMount={true}
      disableSubmitUntilValidAndDirty={false}
      licenseDetailsModalFile="Reverify"
      licenseDetailsModalId="DLOrIDDescription"
      licenseDetailsModalFallback="How to find your DL/ID and DD numbers"
      onCancel={onBack}
    />

    <DpsLinkingLockoutModal />
    <DpsDlrLockoutModal />
    <DpsGuidMismatchModal />
  </div>
);

LinkServiceIdentityView.propTypes = {
  agency: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  appParams: PropTypes.arrayOf(PropTypes.object).isRequired,
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default LinkServiceIdentityView;
